var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tender-status__status"},[_c('span',{staticClass:"tender-title__subtitle"},[_vm._v(_vm._s(_vm.$t('search-filters.status.name')))]),_c('TenderStatusTag',{attrs:{"status":_vm.status}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }